function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "shape",
  fill: "#67C4B0",
  d: "M14,11.272025 C14,9.952875 12.87125,9.44695 12.87125,9.44695 C12.87125,9.44695 13.38225,8.4323 13.38225,7.648825 C13.38225,4.919525 11.339125,2 7.911225,2 C3.984225,2 2.41325,6.1566 2.41325,6.1566 C2.41325,6.1566 1.932875,5.452575 2.08425,3.761025 C2.08425,3.761025 0,5.522225 0,9.19355 C0,12.138275 2.055375,15.65 5.7512,15.65 C8.239,15.65 9.910075,13.554725 9.910075,11.2869 C9.910075,9.141925 8.16095,7.872475 6.523125,7.872475 C5.453525,7.872475 4.567675,8.64755 4.567675,8.64755 C4.86745,7.1303 6.50195,6.52375 6.50195,6.52375 C7.092925,3.727425 10.506825,4.049425 10.506825,4.049425 C10.506825,4.049425 9.08005,4.797375 8.588475,6.1524 C8.588475,6.1524 12.0211,7.341525 12.0211,11.19765 C12.0211,13.94445 10.213875,15.407275 10.213875,15.407275 C10.213875,15.407275 11.930625,14.51145 13.0858,12.63615 C13.323975,12.94065 13.347075,13.3806 13.347075,13.3806 C13.347075,13.3806 14,12.591175 14,11.272025"
});

var SvgOcean = function SvgOcean(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "18px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOcean, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ocean.1910062a.svg";
export { ForwardRef as ReactComponent };